import { render, staticRenderFns } from "./AboutHero.vue?vue&type=template&id=ff219c9c&scoped=true&"
import script from "./AboutHero.vue?vue&type=script&lang=js&"
export * from "./AboutHero.vue?vue&type=script&lang=js&"
import style0 from "./AboutHero.vue?vue&type=style&index=0&id=ff219c9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff219c9c",
  null
  
)

export default component.exports